import { WeekDays } from "common/constants";
import { WorkingHours } from "common/features/restaurant/restaurantModels";
import { format } from "date-fns";

// Returns WeekDay [Sunday/Monday/..]
export const getToday = () => {
  const today = new Date().getDay();
  return WeekDays[today];
};

// 24 - hour Format
export const isInCurrentWindow = (
  currentTime: string,
  openingTime: string,
  closingTime: string
) => {
  let currentHour = parseInt(currentTime.split(":")[0]);
  let openingHour = parseInt(openingTime.split(":")[0]);
  let closingHour = parseInt(closingTime.split(":")[0]);

  let currentMinute = parseInt(currentTime.split(":")[1]);
  let openingMinute = parseInt(openingTime.split(":")[1]);
  let closingMinute = parseInt(closingTime.split(":")[1]);

  // console.log("Hour:", currentHour, openingHour, closingHour);
  // console.log("Minute:", currentMinute, openingMinute, closingMinute);

  if (currentHour >= openingHour && currentHour <= closingHour) {
    if (currentHour == openingHour) {
      if (currentMinute >= openingMinute) {
        return true;
      }
    } else if (currentHour == closingHour) {
      if (currentMinute <= closingMinute) {
        return true;
      }
    } else if (currentHour > openingHour && currentHour < closingHour) {
      return true;
    }
  }

  return false;
};

export const getHoursUntillClosing = (
  openingWindowTime: string,
  closingWindowTime: string
) => {
  let openingHour = parseInt(openingWindowTime.split(":")[0]);
  let closingHour = parseInt(closingWindowTime.split(":")[0]);
  let hours: string[] = [];

  for (let i = openingHour; i <= closingHour; i++) {
    if (i.toString().length === 1) {
      hours.push(`0${i}`);
    } else {
      hours.push(i.toString());
    }
  }

  // const closingMeridian = closingHour < 12 ? "AM" : "PM";
  // closingHour = closingHour > 12 ? closingHour - 12 : closingHour;
  // // console.log(closingWindowTime, closingTime, meridian);

  // let amOrPm = openingHour < 12 ? "AM" : "PM";

  // let d = new Date();
  // let minute = d.getMinutes();

  // let hour = openingHour < 12 ? openingHour : openingHour - 12;

  // console.log("current Hour", hour, closingHour, amOrPm, closingMeridian);

  // if (amOrPm == "AM") {
  //   // AM
  //   for (let i = hour; i <= 12; i++) {
  //     if (i.toString().length === 1) {
  //       hours.push(`0${i}`);
  //     } else {
  //       hours.push(i.toString());
  //     }
  //   }

  //   for (let i = 1; i <= closingHour; i++) {
  //     if (i.toString().length === 1) {
  //       if (!hours.includes(`0${i}`)) {
  //         hours.push(`0${i}`);
  //       }
  //     } else {
  //       if (!hours.includes(i.toString())) {
  //         hours.push(i.toString());
  //       }
  //     }
  //   }
  // } else if (
  //   (amOrPm == "PM" && closingMeridian == "PM") ||
  //   (amOrPm == "AM" && closingMeridian == "AM")
  // ) {
  //   for (let i = hour; i < closingHour; i++) {
  //     if (i.toString().length === 1) {
  //       hours.push(`0${i}`);
  //     } else {
  //       hours.push(i.toString());
  //     }
  //   }
  // }

  return hours;
};

export const getMinutesUntillClosing = (
  openingMinute: number,
  closingMinute: number,
  interval: number
) => {
  // let closingHour = parseInt(closingWindowTime.split(":")[0]);
  // // let openingMinute = parseInt(openingTime.split(":")[1]);
  // let closingMinute = parseInt(closingWindowTime.split(":")[1]);
  // let closingMinute = 60;
  let minutes: string[] = [];

  for (let i = openingMinute; i < closingMinute; i = i + interval) {
    if (i < 10) {
      minutes.push(`0${i}`);
    } else {
      minutes.push(`${i}`);
    }
  }

  if (minutes.length == 0) {
    minutes.push("00");
  }

  return minutes;
};

export const getServiceWindowHourIndex = (
  workingHours: WorkingHours[],
  selectedHour: number
) => {
  let hourIndex = -1;
  workingHours.map((workingHour, index: number) => {
    let openingHour = parseInt(workingHour.openingTime.split(":")[0]);
    let closingHour = parseInt(workingHour.closingTime.split(":")[0]);

    if (selectedHour >= openingHour && selectedHour <= closingHour) {
      hourIndex = index;
    }
  });
  return hourIndex;
};

export const get12HoursTime = (timeString: string) => {
  // console.log(timeString);
  if (timeString && timeString.split(":").length == 3) {
    let hours = timeString.split(":")[0];
    let mins = timeString.split(":")[1];
    let median = "";
    if (parseInt(hours) >= 12) {
      hours = parseInt(hours) - 12 + "";
      median = "PM";
    } else {
      median = "AM";
    }
    return hours.length == 1
      ? "0" + hours + ":" + mins + " " + median
      : hours + ":" + mins + " " + median;
  } else {
    return "";
  }
};

export const getClosingWindowTime = (workingHours: WorkingHours[]) => {
  let closingWindowTime = "";
  if (workingHours && workingHours.length > 0) {
    let currentTime = new Date().toString().split(" ")[4];

    let todayWorkingHours: WorkingHours[] = [];

    // All Days Same Working Hours
    if (workingHours[0].weekday == "All") {
      // Get Todays working Hours
      todayWorkingHours = workingHours.slice();
    } else {
      // Get Todays working Hours
      let todayWeekDay = getToday();
      todayWorkingHours = workingHours.filter(
        (workingHour) => workingHour.weekday == todayWeekDay
      );
    }

    // If Today has Working Hours
    if (todayWorkingHours.length > 0) {
      // Find Working Hour Window for Today
      let workingHourWindowIndex = todayWorkingHours.findIndex(
        (todayWorkingHour) =>
          isInCurrentWindow(
            currentTime,
            todayWorkingHour.openingTime,
            todayWorkingHour.closingTime
          )
      );

      // console.log("Index:", workingHourWindowIndex);

      // Working Hour Window Not Available
      if (workingHourWindowIndex == -1) {
        closingWindowTime = "00:00:00";
      } else {
        // Working Hour Window  Available
        closingWindowTime =
          todayWorkingHours[workingHourWindowIndex].closingTime;
      }
    } else {
      closingWindowTime = "00:00:00";
    }
  } else {
    closingWindowTime = "00:00:00";
  }
  return closingWindowTime;
};

export const getAllServiceWindowHours = (
  workingHours: WorkingHours[],
  weekday: number
) => {
  let dayWorkingHours: WorkingHours[] = [];

  if (workingHours && workingHours.length > 0) {
    if (workingHours[0].weekday == "All") {
      // For All Days
      dayWorkingHours = workingHours.slice();
    } else {
      // Get Specific Day
      dayWorkingHours = workingHours.filter(
        (workingHour) => +workingHour.weekday == weekday
      );
    }
  }
  return dayWorkingHours;
};

export const getOpeningWindowTime = (workingHours: WorkingHours[]) => {
  let openingWindowTime = "";
  if (workingHours && workingHours.length > 0) {
    let currentTime = new Date().toString().split(" ")[4];

    let todayWorkingHours: WorkingHours[] = [];

    // All Days Same Working Hours
    if (workingHours[0].weekday == "All") {
      // Get Todays working Hours
      todayWorkingHours = workingHours.slice();
    } else {
      // Get Todays working Hours
      let todayWeekDay = getToday();
      todayWorkingHours = workingHours.filter(
        (workingHour) => workingHour.weekday == todayWeekDay
      );
    }

    // If Today has Working Hours
    if (todayWorkingHours.length > 0) {
      // Find Working Hour Window for Today
      let workingHourWindowIndex = todayWorkingHours.findIndex(
        (todayWorkingHour) =>
          isInCurrentWindow(
            currentTime,
            todayWorkingHour.openingTime,
            todayWorkingHour.closingTime
          )
      );

      // console.log("Index:", workingHourWindowIndex);

      // Working Hour Window Not Available
      if (workingHourWindowIndex == -1) {
        openingWindowTime = "00:00:00";
      } else {
        // Working Hour Window  Available
        openingWindowTime =
          todayWorkingHours[workingHourWindowIndex].openingTime;
      }
    } else {
      openingWindowTime = "00:00:00";
    }
  } else {
    openingWindowTime = "00:00:00";
  }
  return openingWindowTime;
};

export const getTimeString = (timeStamp: string) => {
  return timeStamp.split("T")[1].split(".")[0].replace("Z", "");
};

export const getDateString = (timeStamp: string) => {
  return timeStamp.split("T")[0];
};

export const getLocalTimeStringFromISO = (dateISO: string) => {
  // ISO String to Local time
  const localDate = new Date(dateISO);
  // console.log(localDate.toString(), );
  return format(localDate, "MM-dd-yyyy hh:mm a");
};
